import { Component, Input } from '@angular/core';
import { DsChipColorVariant, DsChipIconPosition, DsColors, IconStyles, Icons } from '@levelaccess/design-system';
import { $severity } from '../../../../shared/constants/accessibility';
import { SeverityChipUtility } from '../../utility/severity-chip.utility';

@Component({
  selector: 'app-rule-severity',
  templateUrl: './rule-severity.component.html',
  standalone: false,
})
export class RuleSeverityComponent {
  @Input() public severity: string;

  public $severity: typeof $severity;
  public readonly DsChipColorVariant: typeof DsChipColorVariant = DsChipColorVariant;
  public readonly DsChipIconPosition: typeof DsChipIconPosition = DsChipIconPosition;
  public readonly IconStyles: typeof IconStyles = IconStyles;

  constructor() {
    this.$severity = $severity;
  }

  public getSeverityChipVariant(severity: string): DsChipColorVariant {
    return SeverityChipUtility.getChipVariant(severity);
  }

  public getSeverityIcon(severity: string): Icons {
    return SeverityChipUtility.getIcon(severity);
  }

  public getSeverityIconColor(severity: string): keyof typeof DsColors {
    return SeverityChipUtility.getIconColor(severity);
  }
}
